module.exports = __webpack_public_path__ + "img/conogethes-punctiferalis.ed23d1fd.jpg";